module.exports = "<div class=\"app-container\">\n  <router-outlet></router-outlet>\n</div>\n\n<app-footer></app-footer>\n"